import React from 'react'
import cn from 'classnames'
import RemoveButton from '@ui/RemoveButton'

export default function RowItem({ id, children, editable, onRemove, className }) {
  return (
    <div className={cn('row-item-container flex', className, { editable })}>
      {children}
      {editable && onRemove && <RemoveButton id={id} onClick={onRemove} />}
    </div>
  )
}
